module.exports = __webpack_public_path__ + "static/img/commission.da25786a.png";